// Single source of truth for the /discover "What to expect" FAQ.
// Rendered visibly in DiscoverClient and emitted as FAQPage JSON-LD in
// page.tsx — both MUST read from here so the markup always matches the
// visible text exactly (Google requirement). No em/en dashes in this copy.
export const DISCOVER_FAQS = [
  {
    q: "Is this a sales call?",
    a: "No. It is a 30 minute Zoom where we map how you coach today: roster size, tools, and how you deliver programs and check-ins. If LVLUP is not the right fit, we will tell you that too.",
  },
  {
    q: "Do I need to prepare anything?",
    a: "Nothing required. Knowing your current client count and the tools you use helps us tailor the demo, but we can figure it out together on the call either way.",
  },
  {
    q: "What happens after the call?",
    a: "You get a tailored proposal for the High Value plan covering features, pricing, and timeline. No chasing, no pressure. If you go ahead, your branded app is typically live in the stores about 20 days after you send your branding assets.",
  },
  {
    q: "Can I just start a trial instead?",
    a: "Yes. Basic and Pro include a 14 day free trial with no card needed. The discovery call is for coaches and studios who want the tailor made High Value setup.",
  },
] as const;
